import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {TaskDto, TaskLogsDTO} from '../model/Task';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

    private baseUrl = `${environment.apiBaseUrl}/tasks`;

    constructor(private http: HttpClient){}

    getTasks(pageSize: number, page: number): Observable<TaskDto[]> {
        return this.http.get<TaskDto[]>(`${this.baseUrl}/${pageSize}/${page}`);
    }

    getAllLogs(taskId: string): Observable<TaskLogsDTO> {
        return this.http.get<TaskLogsDTO>(`${this.baseUrl}/logs/${taskId}`);
    }

    getLogs(taskId: string, timestamp: number): Observable<TaskLogsDTO> {
        return this.http.get<TaskLogsDTO>(`${this.baseUrl}/logs/${taskId}/${timestamp}`);
    }

}
